import { ShowAllData } from '@/apiError/apiShow';
import { rules } from '@/utils/validation/FormValidation';
import { EditFilled } from '@ant-design/icons';
import { Button, Col, Form, Input, Layout, Modal, Row, Space } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUpdateVersions } from './hooks/useVersions';
import { AntButton } from '@/common/ant-components/AntButton';

const { Content } = Layout;

const EditVersion = ({ id, refetch }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [referenceId, setReferenceId] = useState(null);
  const [open, setOpen] = useState(false);

  const showModal = async () => {
    try {
      setOpen(true);
      const { data } = await ShowAllData.showDetails(
        `/superadmin/versions/${id}/`,
        navigate,
      );
      setReferenceId(data.referenceId);
      form.setFieldsValue(data);
    } catch (error) {
      console.error('Error fetching version data:', error);
      setOpen(false);
    }
  };

  const closeModal = () => {
    setOpen(false);
  };

  const { mutateAsync: updateVersion } = useUpdateVersions();

  const handleSubmit = () => {
    const values = form.getFieldsValue();
    updateVersion(
      { ...values, referenceId: id },
      {
        onSuccess: () => {
          setOpen(false);
          refetch();
        },
        onError: (error) => {
          console.error('Error updating version:', error);
        },
      },
    );

    refetch();
  };

  return (
    <>
      <div size="medium" className="edit tw-cursor-pointer" onClick={showModal}>
        <EditFilled color="blue" />
      </div>
      <Modal
        open={open}
        onCancel={closeModal}
        title="Edit Version"
        footer={null}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="versionName" label="Version Name">
                <Input placeholder="Version Name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="price" label="Price">
                <Input placeholder="Price" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="description" label="Description">
                <TextArea placeholder="Description" />
              </Form.Item>
            </Col>
          </Row>

          <div style={{ textAlign: 'right', marginTop: '12px' }}>
            <Space size="large">
              <Button
                // htmlType="submit"
                className="submit-button"
                type="primary"
                onClick={() => handleSubmit()}
              >
                Update
              </Button>
              <Button className="cancel-button" onClick={closeModal}>
                Cancel
              </Button>
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default EditVersion;
